import createFetchClient from 'openapi-fetch';
import { BaseUrl } from '~/types/baseUrl';
import createClient from 'openapi-react-query';
import { paths } from './openapi';

const baseUrl: BaseUrl = {
  production: 'https://platform.versori.com/api/sparkboard/v1alpha1',
  staging: 'https://platform-staging.versori.com/api/sparkboard/v1alpha1',
  development: 'http://localhost:8000',
};

export const switchboardAiBaseUrl = import.meta.env.DEV
  ? baseUrl.development
  : import.meta.env.VITE_STAGING
    ? baseUrl.staging
    : baseUrl.production;

export const switchboardAiFetchClient = createFetchClient<paths>({
  baseUrl: switchboardAiBaseUrl,
  credentials: 'include',
  mode: 'cors',
  headers: {
    ...(import.meta.env.VITE_API_JWT && {
      'X-Versori-Internal-Token': import.meta.env.VITE_API_JWT,
    }),
  },
});

export const switchboardAi = createClient(switchboardAiFetchClient);
